export default "__VITE_ASSET__B5lGc5LP__"